/* AUTO-GENERATED FILE, DO NOT EDIT! */
import React from "react";
import styles from "./typography.module.less";


export const Title_20_Coral_Primary_Light_20: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_20_Coral_Primary_Light_20} {...props} />;
};

export const Title_20_Coral_Primary_Regular_20: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_20_Coral_Primary_Regular_20} {...props} />;
};

export const Title_20_Coral_Empasis_20: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_20_Coral_Empasis_20} {...props} />;
};

export const Title_20_Coral_Strong_emphasis_20: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_20_Coral_Strong_emphasis_20} {...props} />;
};


export const Title_40_Coral_emphasis_40: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_40_Coral_Empasis_40} {...props} />;
};

export const Title_28_Coral_Strong_emphasis_24: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_28_Coral_Strong_emphasis_24} {...props} />;
};

export const Title_34_Coral_Strong_emphasis_34: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_34_Coral_Strong_emphasis_34} {...props} />;
};

export const Title_24_Coral_Strong_emphasis_24: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_24_Coral_Strong_emphasis_24} {...props} />;
};


export const Title_16_Coral_Primary_Light_16: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_16_Coral_Primary_Light_16} {...props} />;
};

export const Title_16_Coral_Primary_Regular_16: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_16_Coral_Primary_Regular_16} {...props} />;
};

export const Title_16_Coral_Empasis_16: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_16_Coral_Empasis_16} {...props} />;
};

export const Title_16_Coral_Strong_emphasis_16: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Title_16_Coral_Strong_emphasis_16} {...props} />;
};

export const Body_14_Coral_Primary_Light_14: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_14_Coral_Primary_Light_14} {...props} />;
};

export const Body_14_Coral_Primary_Regular_14: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_14_Coral_Primary_Regular_14} {...props} />;
};

export const Body_14_Coral_Empasis_14: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_14_Coral_Empasis_14} {...props} />;
};

export const Body_14_Coral_Strong_emphasis_14: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_14_Coral_Strong_emphasis_14} {...props} />;
};

export const Body_16_Coral_Strong_emphasis_16: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_16_Coral_Strong_emphasis_16} {...props} />;
};

export const Body_16_Coral_Emphasis_16: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_16_Coral_Emphasis_16} {...props} />;
};

export const Body_16_Coral_Primary_Regular_16: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_16_Coral_Primary_Regular_16} {...props} />;
};


export const Body_12_Coral_Primary_Light_12: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_12_Coral_Primary_Light_12} {...props} />;
};

export const Body_12_Coral_Primary_Regular12: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_12_Coral_Primary_Regular12} {...props} />;
};

export const Body_12_Coral_Empasis_12: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_12_Coral_Empasis_12} {...props} />;
};

export const Body_12_Coral_Strong_emphasis_12: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_12_Coral_Strong_emphasis_12} {...props} />;
};

export const Body_10_Coral_Primary_Light_10: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_10_Coral_Primary_Light_10} {...props} />;
};

export const Body_10_Coral_Primary_Regular10: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_10_Coral_Primary_Regular10} {...props} />;
};

export const Body_10_Coral_Empasis_10: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_10_Coral_Empasis_10} {...props} />;
};

export const Body_10_Coral_Strong_emphasis_10: React.FC<React.HTMLAttributes<HTMLParagraphElement>> = (props) => {
  return <p className={styles.Body_10_Coral_Strong_emphasis_10} {...props} />;
};
